/**
 * TASK-471: Canonical 12 sub-asset-class taxonomy for the strategic allocation table.
 * MUST stay in sync with the DB CHECK in backend migration 158_create_house_model_allocations.sql
 * (a unit test asserts parity).
 */
export const SUB_ASSET_CLASSES = [
  { assetClass: 'Equities',     subAssetClass: 'Domestic (CHF)' },
  { assetClass: 'Equities',     subAssetClass: 'Foreign (Dev. Markets)' },
  { assetClass: 'Equities',     subAssetClass: 'Emerging Markets' },
  { assetClass: 'Fixed Income', subAssetClass: 'Domestic Bonds (CHF)' },
  { assetClass: 'Fixed Income', subAssetClass: 'Foreign Bonds (G7)' },
  { assetClass: 'Fixed Income', subAssetClass: 'Emerging Market Bonds' },
  { assetClass: 'Real Estate',  subAssetClass: 'Swiss Real Estate' },
  { assetClass: 'Real Estate',  subAssetClass: 'Global Listed REITs' },
  { assetClass: 'Alternatives', subAssetClass: 'Cryptocurrencies' },
  { assetClass: 'Alternatives', subAssetClass: 'Private Markets' },
  { assetClass: 'Alternatives', subAssetClass: 'Commodities / Gold' },
  { assetClass: 'Liquidity',    subAssetClass: 'Cash & Money Market' },
] as const;

export const SUB_ASSET_CLASS_VALUES =
  SUB_ASSET_CLASSES.map((s) => s.subAssetClass) as [string, ...string[]];

/** Whole-SAC sentinel for the optional industryGroup/region refine keys. */
export const WHOLE_SAC = '*';
